const SET_ANNOTATION = (state, obj) => {
  let { page, book_id, annotation } = obj

  if (!state.annotations[book_id]) {
    state.annotations[book_id] = []
  }
  state.annotations[book_id][page] = annotation
}

const SET_ANNOTATIONS = (state, obj) => {
  state.annotations = obj
}

export default {
  SET_ANNOTATION,
  SET_ANNOTATIONS
}
